import { createContext, RefObject, useContext } from "react";
import { Signal, useSignalValue } from "@/utils/signal";
import { truthOrFail } from "@/utils/helpers";

export interface Context<T = unknown> {
  /// Popover open state
  readonly open: Signal<boolean>;
  ///
  readonly loading: Signal<boolean>;
  /// Input value typed by user
  readonly input: Signal<string>;
  ///
  readonly selected: Signal<ListState<T>>;
  ///
  readonly list: RefObject<ListHandle>;
  ///
  readonly onSelectItem: (item: T) => void;
  ///
  readonly onPopItem: () => void;
  ///
  readonly reset: () => void;
}

export const Unselected = Symbol("Unselected");
export type Unselected = typeof Unselected;

export interface ListState<T> {
  index: number | undefined;
  value: T | Unselected;
}

export interface ListHandle {
  selectBy(diff: number): void;
  reset(index?: number | undefined): void;
}

export const Context = createContext<Context | null>(null);

export function useAutoComplete<T>(): Context<T> {
  return truthOrFail(
    useContext(Context),
    "auto complete context not found",
  ) as Context<T>;
}

export function useAutoCompleteInputValue() {
  const { input } = useAutoComplete();
  return useSignalValue(input);
}
